// extracted by mini-css-extract-plugin
export default {"cart-summary":"styles_cart-summary__93vOL","fullView":"styles_fullView__FSxbm","shimmer":"styles_shimmer__LJBha"};